import channels from "../../../data/channels"

// Mirrors `pathPrefix` in gatsby-config.js. Stripped only when present, so it
// also works for builds without --prefix-paths.
export const PATH_PREFIX = "/blog"

// Value sent as `business_line` on every blog page_view.
export const BUSINESS_LINE = "blog"

// Channel (category) landing pages, e.g. "health-and-wellness". "Home" is "/".
export const channelSlugs = channels
  .map((channel) => channel.path.replace(/^\/|\/$/g, ""))
  .filter(Boolean)

/**
 * Blog page types (prefix stripped):
 *   /                     -> blog_index
 *   /<channel>/           -> blog_category   (page_category = channel slug)
 *   /author/<id>/         -> blog_author     (page_detail = author id)
 *   /doctor/<id>/         -> blog_doctor     (page_detail = doctor id)
 *   /<post-uid>/          -> blog_post       (page_detail = post uid)
 *
 * Single source of truth for the head GA4 page_view and the Segment page().
 * Must stay ES5 and self-contained (parameters only, no closures): the head
 * snippet embeds it via Function.prototype.toString.
 */
export function classifyBlogPath(pathname, slugs, prefix) {
  var sitePath = pathname || "/"
  if (sitePath === prefix || sitePath.indexOf(prefix + "/") === 0) {
    sitePath = sitePath.substring(prefix.length) || "/"
  }
  var segments = sitePath.split("/").filter(Boolean)
  var page_type
  var page_category = null
  var page_detail = null
  if (segments.length === 0) {
    page_type = "blog_index"
  } else if (segments[0] === "author" && segments[1]) {
    page_type = "blog_author"
    page_detail = segments[1]
  } else if (segments[0] === "doctor" && segments[1]) {
    page_type = "blog_doctor"
    page_detail = segments[1]
  } else if (segments.length === 1 && slugs.indexOf(segments[0]) > -1) {
    page_type = "blog_category"
    page_category = segments[0]
  } else {
    page_type = "blog_post"
    page_detail = segments[0]
  }
  return {
    page_type: page_type,
    page_category: page_category,
    page_detail: page_detail,
  }
}

export const getBlogPageClassification = (pathname) => ({
  ...classifyBlogPath(pathname, channelSlugs, PATH_PREFIX),
  business_line: BUSINESS_LINE,
})
